import { QueryClient } from '@tanstack/react-query';
import { message } from 'antd';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, err) => {
          const status = (err as { status?: number })?.status;
          if (status === 401 || status === 403 || status === 404) return false;
          return failureCount < 3;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
        onError: (err) => {
          message.error((err as Error)?.message ?? '操作失败');
        },
      },
    },
  });
}
